import { ICreateNewEvent, IEditEvent, IDeleteEvent, IAiTask, IEditEventVisibility } from '@app-types/websocket/event.types';
import { IAiScheduleTurn } from '@app-types/websocket/aiSchedule.types';

import { createAction } from 'redux-act';

export const createEvent = createAction<ICreateNewEvent>('Create Event');
export const editEvent = createAction<IEditEvent>('Edit Event');
export const addViewerToEvent = createAction<IEditEventVisibility>("Adding viewer to event")
export const deleteEvent = createAction<IDeleteEvent>('Delete Event');
export const seenEvent = createAction<number>('Seen Event');
export const completedEvent = createAction<number>('Completed Event');
export const analyzeImage = createAction<number>('analyze Image with an event');
export const analyzeReceiptImage = createAction<number>('analyze Image with a receipt');
export const dismissAnalyzedImage = createAction<number>('dismiss analyzed Image');
export const aiTask = createAction<IAiTask>('send AI Task');
export const dismissAiTask = createAction<number>('dismiss ai Task');
export const aiScheduleTurn = createAction<IAiScheduleTurn>('send AI Schedule Turn');
export const clearAiScheduleUpdate = createAction('clear ai schedule update');



// WEBPACK FOOTER //
// ./src/services/events/event.action.ts